import React, { useState, useEffect, useRef, useCallback } from 'react';
import { connect } from "react-redux";
import FullCalendar from '@fullcalendar/react';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import interactionPlugin from '@fullcalendar/interaction';
import { Trans } from 'react-i18next';

import axios from "axios";
import moment from "moment";

import ModalRoutes from '../../ModalRoutes';
import Navbar from '../../../Navbar';
import AlertBar from '../../../Stakeholder/AlertBar';
import { useLazyQuery } from '@apollo/client';
import { openPullout, endPulloutEdit } from '../../../../Actions/stakeholderActions';
import colours from '../../../Common/DesignSystem/Colours';
import { Input } from '../../../Common/DesignSystem/Input';
import { LoadingIcon } from '../../../Common/Loading_Icon';
import { setReturnReleaseBookings } from '../../../../Actions/dataActions';
import { checkCredentials } from '../../../../Helpers/checkCredentials';
import { GET_BOOKINGS, GET_PENDING_BOOKINGS } from '../../../../GraphQL/Queries/bookings';
import CheckboxTree from 'react-checkbox-tree';
import Toggle from 'react-toggle';
import {
    MdCheckBox,
    MdCheckBoxOutlineBlank,
    MdChevronRight,
    MdKeyboardArrowDown,
    MdAddBox,
    MdIndeterminateCheckBox,
    MdFolder,
    MdFolderOpen,
    MdInsertDriveFile
} from "react-icons/md";
import Icon from '../../../Common/DesignSystem/Icons/Icon';
import { DivisionIcon, VCIcon } from '../../../Common/Buttons/TypeIcons';
import { clickOutside } from '../../../../Helpers/clickOutside';
import { debounce } from "lodash";

import { useQueryParams } from '../../../../hooks/common/useQueryParams';
import { getTimeZoneAbbreviation } from '../../../../Helpers/getTimeZoneAbbreviation';

import Skeleton from 'react-loading-skeleton';
import { CaptionMedium, P1Bold, P2, P3, P3Bold } from '../../../Common/DesignSystem/Text';
import HighLighter from '../../../Common/DesignSystem/HighLighter';
import Button from '../../../Common/DesignSystem/Button';
import { TabItem, Tabs } from '../../../Common/DesignSystem/Tabs';

const SHBookings = (props) => {
    const innerFilterRef = useRef(null);
    const innerSettingsRef = useRef(null);
    const calendarRef = useRef(null);

    const { location, history } = props;
    const { query, setParams } = useQueryParams({ location, history });

    const [weekendsVisible, setWeekendsVisible] = useState(true);
    const [filtersChecked, setFiltersChecked] = useState([]);
    const [filtersExpanded, setFiltersExpanded] = useState([]);
    const [showFilters, setShowFilters] = useState(false);
    const [showSettings, setShowSettings] = useState(false);
    const [totalData, setTotalData] = useState(null);
    const [events, setEvents] = useState([]);
    const [resources, setResources] = useState([]);
    const [calendarView, setCalendarView] = useState('rtmo');
    const [calendarTitle, setCalendarTitle] = useState('');
    const [checkedVCs, setCheckedVCs] = useState([]);
    const [editingEvents, setEditingEvents] = useState([]);
    const [calendarLoading, setCalendarLoading] = useState(false);
    const [currentCreatedBooking, setCurrentCreatedBooking] = useState(null);

    const [displaySearchTerm, setDisplaySearchTerm] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [filterBy, setFilterBy] = useState('');
    const [shouldMergeCalendarRows, setShouldMergeCalendarRows] = useState(true);

    document.body.style.overflowY = 'hidden';

    clickOutside(innerFilterRef, () => {
        if (showFilters)
            setShowFilters(false);
    });

    clickOutside(innerSettingsRef, () => {
        if (showSettings)
            setShowSettings(false);
    });

    const filterNodesSH = props.userSession?.user?.profile_access?.active_sh_access.map((current) => {
        let label_node = props.userSession?.user?.profile_access?.active_sh_vmh_access.find((item) => { return item.SH_ID == current.stakeholderId }).stakeholder
        return (
            {
                value: current.stakeholderId,
                label: label_node.Company + " " + label_node.Division,
                icon: DivisionIcon(label_node, null, null, null, true),
                children: current.vehicleCenterIds.map((vc) => {
                    let child_label = props.userSession?.user?.profile_access?.active_sh_vmh_access.find((item) => { return item.VMH_ID == vc }).vmh;
                    return {
                        value: current.stakeholderId + "_" + vc,
                        label: child_label.Display_Name + " - " + child_label.Display_City,
                        icon: VCIcon(child_label, null, null, null, true),
                    }
                })
            }
        );
    });

    const filterNodesVC = props.userSession?.user?.profile_access?.active_vmh_access.map((current) => {
        let label_node = props.userSession?.user?.profile_access?.active_sh_vmh_access.find((item) => { return item.VMH_ID == current.VMH_ID }).vmh
        return (
            {
                value: current.VMH_ID,
                label: label_node.Display_Name + " " + label_node.Display_City,
                icon: VCIcon(label_node, null, null, null, true),
            }
        );
    });

    const formatFilters = (filters) => {
        let results = [];
        if (filters && filters.length > 0) {
            filters.forEach((item) => {
                let items = item?.split('_');
                if (!results.find((sh) => sh.stakeholderId == items[0])) {
                    results.push({
                        stakeholderId: parseInt(items[0]), vehicleCenterIds: filters.filter((val) => {
                            return val?.split('_')[0] == items[0];
                        }).map((str) => parseInt(str?.split('_')[1]))
                    })
                }
            });
            return results;
        }
    }

    const isChecked = (item) => {
        let res = filtersChecked.filter((filter) => { return filter.includes(item) });
        let total = props.userSession?.user?.profile_access?.active_vmh_access.find((vc) => vc.VMH_ID == item).SH_ID;
        if (res?.length && total?.length) {
            return res.length == total.length;
        } else
            return false;
    }

    const icons = {
        check: <MdCheckBox className="rct-icon rct-icon-check" style={{ color: colours.primary.blue }} />,
        uncheck: <MdCheckBoxOutlineBlank className="rct-icon rct-icon-uncheck" />,
        halfCheck: <MdIndeterminateCheckBox className="rct-icon rct-icon-half-check" style={{ color: colours.primary.blue }} />,
        expandClose: <MdChevronRight className="rct-icon rct-icon-expand-close" />,
        expandOpen: <MdKeyboardArrowDown className="rct-icon rct-icon-expand-open" />,
        expandAll: <MdAddBox className="rct-icon rct-icon-expand-all" />,
        collapseAll: <MdIndeterminateCheckBox className="rct-icon rct-icon-collapse-all" />,
        parentClose: <MdFolder className="rct-icon rct-icon-parent-close" />,
        parentOpen: <MdFolderOpen className="rct-icon rct-icon-parent-open" />,
        leaf: <MdInsertDriveFile className="rct-icon rct-icon-leaf-close" />
    };

    const [getPendingBookings] = useLazyQuery(GET_PENDING_BOOKINGS, {
        variables: {
            stakeholderAndVehicleCenterInputs: props.userSession?.user?.profile_access?.active_sh_access,
        },
        errorPolicy: 'all',
        fetchPolicy: 'network-only',
    });

    const [searchData, { data, loading, called, refetch }] = useLazyQuery(GET_BOOKINGS, {
        variables: {
            startDate: moment().subtract(1, 'year').format('YYYY-MM-DD'),
            endDate: moment().add(1, 'year').format('YYYY-MM-DD'),
            stakeholderAndVehicleCenterInputs: filtersChecked.length > 0 ? formatFilters(filtersChecked) : props.userSession?.user?.profile_access?.active_sh_access,
            vehicleSearchTerm: searchTerm,
            filterInput: null,
            first: 50,
            after: null
        },
        errorPolicy: 'all'
    });

    useEffect(() => {
        setCalendarLoading(true);

        const {
            filtersChecked: filtersQueryParam,
            searchTerm: searchTermQueryParam,
            filterBy: filterByQueryParam,
        } = query;

        if (filtersQueryParam) {
            const filters = filtersQueryParam?.split(',');
            setFiltersChecked(filters);
        }

        if (searchTermQueryParam) {
            setSearchTerm(searchTermQueryParam);
            setDisplaySearchTerm(searchTermQueryParam);
        }

        if (filterByQueryParam) {
            setFilterBy(filterByQueryParam);
        }

        const currentBooking = JSON.parse(localStorage.getItem('currentBooking'))
        if (currentBooking) {
            // open pullout for current booking in local storage
            axios.get('/ajax/booking/' + currentBooking.BOOK_ID).then((response) => {
                const pulloutBooking = {
                    ...currentBooking,
                    vehicle: response?.data.vehicle,
                    highlightEvent: highlightEvent,
                    onCancel: cancelEvent,
                    loadData: refetchData,
                    calendarRef: calendarRef.current.getApi(),
                    ...response?.data.booking
                };

                props.dispatch(openPullout(pulloutBooking));
                localStorage.removeItem('currentBooking');
            })
        }
    }, []);

    const getMoreData = () => {
        setShouldMergeCalendarRows(true);

        if (totalData?.getCalendarRows?.metaData?.nextCursor) {
            searchData({
                variables: {
                    "startDate": moment().subtract(1, 'year').format('YYYY-MM-DD'),
                    "endDate": moment().add(1, 'year').format('YYYY-MM-DD'),
                    "stakeholderAndVehicleCenterInputs": filtersChecked.length > 0 ? formatFilters(filtersChecked) : props.userSession?.user?.profile_access?.active_sh_access,
                    "vehicleSearchTerm": searchTerm,
                    "first": 50,
                    "after": totalData.getCalendarRows.metaData.nextCursor
                }
            });
        }
    }

    const addEvent = (booking) => {
        setCurrentCreatedBooking(booking);

        refetchData();
    }

    const cancelEvent = () => {
        refetchData();
    }

    const highlightEvent = (event, val = true) => {
        if (event) {
            calendarRef.current?._calendarApi?.getEventById(event.id)?.setProp('classNames', val ? 'ds-cal-selected-booking' : '');
        }
    }

    const refetchData = async (options = {}) => {
        setCalendarLoading(true);
        setShouldMergeCalendarRows(false);
        setEvents([]);

        props.dispatch(endPulloutEdit());

        await searchData(options);

        setCalendarLoading(false);
    }

    useEffect(() => {
        if (shouldMergeCalendarRows && data && totalData && data.getCalendarRows?.calendarRows[0]?.vehicle?.id !== totalData.getCalendarRows?.calendarRows[0]?.vehicle?.id) {
            let existing = totalData.getCalendarRows;
            let incoming = data.getCalendarRows;

            const { calendarRows, metaData } = incoming;

            let result = { getCalendarRows: {} };
            result.getCalendarRows.calendarRows = [...existing.calendarRows, ...calendarRows]; // Merge existing items with the items from incoming
            result.getCalendarRows.metaData = metaData;

            setTotalData(result);
        } else if (data) {
            setTotalData(data);
        }
    }, [data])

    useEffect(() => {
        calendarRef.current?._calendarApi.changeView(calendarView);
        setCalendarTitle(calendarRef.current?._calendarApi.view.title);
        if (!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)) {
            // $('.fc-scrollgrid').attr('style', 'width: auto;'); //required for the sticky vehicle column on the left to function properly, setting this in css causes the calendar to render differently
            $('.fc-scrollgrid').attr('style', 'width: max-content; display: inline'); //required for the sticky vehicle column on the left to function properly, setting this in css causes the calendar to render differently
        } else {
            // $('.fc-scrollgrid').attr('style', 'width: auto;'); //required for the sticky vehicle column on the left to function properly, setting this in css causes the calendar to render differently
            $('.fc-scrollgrid').attr('style', 'width: max-content;'); //required for the sticky vehicle column on the left to function properly, setting this in css causes the calendar to render differently
        }
    }, [calendarView])

    const getPrev = () => {
        calendarRef.current?._calendarApi.prev();
        setCalendarTitle(calendarRef.current?._calendarApi.view.title);
    }

    const getHalfPrev = () => {
        calendarRef.current?._calendarApi.incrementDate({ days: -7 });
        setCalendarTitle(calendarRef.current?._calendarApi.view.title);
    }

    const toToday = () => {
        calendarRef.current?._calendarApi.today();
        setCalendarTitle(calendarRef.current?._calendarApi.view.title);
    }

    const getHalfNext = () => {
        calendarRef.current?._calendarApi.incrementDate({ days: 7 });
        setCalendarTitle(calendarRef.current?._calendarApi.view.title);
    }

    const getNext = () => {
        calendarRef.current?._calendarApi.next();
        setCalendarTitle(calendarRef.current?._calendarApi.view.title);
    }

    const updateSearchTerm = useCallback(debounce(term => {
        setShouldMergeCalendarRows(false);
        setSearchTerm(term)
    }, 500), []);

    const handleSearchVehicles = event => {
        const { value } = event.target;

        setShouldMergeCalendarRows(false);
        setDisplaySearchTerm(value);
        updateSearchTerm(value);
    };

    const clearSearchTerm = () => {
        setCalendarLoading(true);
        setShouldMergeCalendarRows(false);
        setDisplaySearchTerm('');
        setSearchTerm('');

        // searchData();
    }

    const filterByPendingBookings = async () => {
        setCalendarLoading(true);

        const pendingBookingsResponse = await getPendingBookings();
        const pendingBookings = pendingBookingsResponse?.data?.getPendingBookings?.bookings;
        if (!pendingBookings) return;

        const vehicleIds = [...new Set(pendingBookings.map(booking => booking.vehicle.id))];

        searchData({
            variables: {
                startDate: moment().subtract(1, 'year').format('YYYY-MM-DD'),
                endDate: moment().add(1, 'year').format('YYYY-MM-DD'),
                stakeholderAndVehicleCenterInputs: filtersChecked.length > 0 ? formatFilters(filtersChecked) : props.userSession?.user?.profile_access?.active_sh_access,
                vehicleSearchTerm: searchTerm,
                filterInput: {
                    includeInactiveVehicles: true,
                    vehicleIds,
                },
                first: vehicleIds?.length > 0 ? vehicleIds.length : 20,
                after: null,
            }
        });
    }

    const filterCalendarBy = async ({ queryParam }) => {
        const filtersByQueryParam = {
            pendingBookings: filterByPendingBookings,
        };

        const filterCalendar = await filtersByQueryParam[queryParam];
        if (filterCalendar) filterCalendar();
    }

    useEffect(() => {
        setParams([
            { name: 'searchTerm', value: searchTerm },
            { name: 'filtersChecked', value: filtersChecked },
            { name: 'filterBy', value: filterBy }
        ]);

        if ((searchTerm || filtersChecked.length) && !filterBy) {
            let new_vcs = props.userSession?.user?.profile_access?.active_vmh_access.map((access) => {
                if (isChecked(access.VMH_ID))
                    return access.VMH_ID;
            }).filter((el) => { return el !== undefined });
            setCheckedVCs(new_vcs);
            refetchData();
        }

        if (!filtersChecked.length) {
            setCheckedVCs([]);
        }

        if (filterBy) {
            filterCalendarBy({ queryParam: filterBy });
        }

        // clean search and filters
        if (!searchTerm && !filtersChecked.length && !filterBy) {
            refetchData({
                startDate: moment().subtract(1, 'year').format('YYYY-MM-DD'),
                endDate: moment().add(1, 'year').format('YYYY-MM-DD'),
                stakeholderAndVehicleCenterInputs: filtersChecked.length > 0 ? formatFilters(filtersChecked) : props.userSession?.user?.profile_access?.active_sh_access,
                vehicleSearchTerm: searchTerm,
                filterInput: null,
                first: 50,
                after: null
            });
        }
    }, [searchTerm, filtersChecked, filterBy]);

    const handleDateSelect = (selectInfo) => {
        let calendarApi = selectInfo.view.calendar;
        let isWeek = false;

        //handle the logic differently for 'week' view
        if (calendarApi.currentDataManager?.state?.currentViewType === 'resourceTimelineWeek')
            isWeek = true;

        //if the selection overlaps an existing event (includes turnaround time events) ignore the selection
        if (calendarRef.current.props.events.find((item, index) => {
            if (selectInfo.resource.id == item.resourceId) {
                if (moment(selectInfo.start).isBefore(moment(item.end).subtract(isWeek ? 0 : 1, 'day')) && moment(selectInfo.end).isAfter(moment(item.start).add(isWeek ? 0 : 1, 'day')) && item.display !== 'background') {
                    calendarApi.unselect();
                    return item;
                }
            }
        }) === undefined) {
            // Validation succeeded, proceed with event creation form
            const selectedCalendarRow = totalData?.getCalendarRows?.calendarRows.find(row => row.vehicle.sourceVehicleId === selectInfo.resource._resource.extendedProps.v_id);

            props.dispatch(openPullout({
                ID: selectInfo.resource._resource.id,
                V_ID: selectInfo.resource._resource.extendedProps.v_id,
                start: selectInfo.startStr,
                vehicleManagementHub: selectedCalendarRow?.vehicleManagementHub,
                end: selectInfo.endStr, //corrects weird date selection behaviour
                calendarRef: calendarRef.current.getApi(),
                onAdd: addEvent,
                loadData: refetchData,
                resource: selectInfo.resource
            }, 'new'))
        } else {
            calendarApi.unselect();
        }

    }

    const handleEventClick = (clickInfo) => {
        axios.get('/ajax/booking/' + clickInfo.event.extendedProps.sourceBookingId)
            .then((response) => {
                props.dispatch(openPullout({
                    event: clickInfo.event,
                    vehicle: response?.data.vehicle,
                    highlightEvent: highlightEvent,
                    onCancel: cancelEvent,
                    loadData: refetchData,
                    calendarRef: calendarRef.current.getApi(),
                    extendedProps: clickInfo.event.extendedProps,
                    ...response?.data.booking
                }, null));
            })
    }

    //used watered-down version of existing method to call one result rather than entire list, for the purpose of retrieving the booking requests and release/check-ins
    const grabAlertbarData = () => {
        axios({
            method: 'post',
            url: '/ajax/calendar',
            data: {
                search_term: $("#searchbar").val(),
                vmh: '1234',
                sh: '1028',
                start_date: moment().subtract(1, 'month').format("YYYY-MM-DD"),
                end_date: moment().format("YYYY-MM-DD"),
                per_page: 1
            }
        })
            .then(function (response) {
                checkCredentials(response)
                // props.dispatch(setList("SET_BOOKING_REQUEST_LIST", response?.data.pending_bookings));
                props.dispatch(setReturnReleaseBookings(response?.data.return_release_bookings));
            })
            .catch(function (error) {
                if (error.response?.status == 401) {
                    showStatusMsg(error.response?.data.error);
                } else if (error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
    }

    let skeletonResources = [];
    for (let i = 0; i < 20; i++) {
        skeletonResources.push({
            id: i,
            groupId: -1,
        })
    }

    const getTurnaroundTimes = (start, end, vehicleManagementHub = {}) => {
        start = moment(start, 'YYYY-MM-DD HH:mm:ss').subtract(vehicleManagementHub.turnPreDays, 'days').subtract(vehicleManagementHub.turnPreHours, 'hours');
        end = moment(end, 'YYYY-MM-DD HH:mm:ss').add(vehicleManagementHub.turnPostDays, 'days').add(vehicleManagementHub.turnPostHours, 'hours');

        if (parseInt(start.clone().format('HH').substring(0, 2)) < 9)
            start.subtract(16, 'hours');

        if (parseInt(end.clone().format('HH').substring(0, 2)) > 17)
            end.add(16, 'hours');

        if (start.clone().format('ddd') == 'Sun')
            start.subtract(48, 'hours');

        if (start.clone().format('ddd') == 'Sat')
            start.subtract(24, 'hours');

        if (end.clone().format('ddd') == 'Sat')
            end.add(48, 'hours');

        if (end.clone().format('ddd') == 'Sun')
            end.add(24, 'hours');

        return { startTime: moment(start).format('YYYY-MM-DDTHH:mm:ssZ'), endTime: moment(end).format('YYYY-MM-DDTHH:mm:ssZ') };
    }

    useEffect(() => {
        const currentBooking = props.stakeholder.current_booking;

        // remove drafts from calendar
        const draftEvents = events.filter(event => event.id.includes('draft'));
        if (draftEvents.length) setEvents(currentEvents => currentEvents.filter(event => !event.id.includes('draft')));

        // add editing events to calendar
        if (editingEvents.length && (!currentBooking || !currentBooking?.edit)) {
            setEvents(currentEvents => [...currentEvents, ...editingEvents]);
            setEditingEvents([]);
        }

        if (currentBooking?.draft) {
            // remove saved event from calendar if editing to prevent duplicate event with the editable draft one
            if (currentBooking.edit && !editingEvents.length) {
                const bookingId = currentBooking.extendedProps.bookingId || currentBooking.BOOK_ID;
                const currentEvents = events.filter(event => event.id.replace('_turnaround', '') == bookingId);

                if (currentEvents.length) {
                    setEvents(currentEvents => currentEvents.filter(event => event.id.replace('_turnaround', '') != bookingId));
                    setEditingEvents(currentEvents);
                };
            }

            const draftEvent = {
                id: `${currentBooking.ID}_draft`,
                resourceId: parseInt(currentBooking.ID),
                display: 'block',
                title: `${moment(currentBooking.start).format('M/D, h:mma').replace('m', '')} - ${moment(currentBooking.end).format('M/D, h:mma').replace('m', '')}`,
                start: currentBooking.start,
                end: currentBooking.end,
                color: colours.primary.blue,
                extendedProps: currentBooking.extendedProps
            };

            const { startTime, endTime } = getTurnaroundTimes(currentBooking.start, currentBooking.end, currentBooking.vehicleManagementHub);

            const draftEventBackground = {
                id: `${currentBooking.ID}_draft_turnaround`,
                resourceId: parseInt(currentBooking.ID),
                display: 'background',
                start: startTime,
                end: endTime,
                color: colours.primary.blue,
                extendedProps: currentBooking.extendedProps
            }

            setEvents(currentEvents => {
                const eventsWithoutDrafts = currentEvents.filter(event => !event.id.includes('draft'));

                return [...eventsWithoutDrafts, draftEvent, draftEventBackground];
            });
        }
    }, [props.stakeholder.current_booking]);

    const openVehicleDetails = (vehicle) => {
        const { path } = props.match
        const { id, extendedProps: { v_id } } = vehicle.resource;

        props.history.push(`${path}/vehicle/${v_id}/Overview/${id}`);
    }



    useEffect(() => {
        if (totalData) {
            let resources = [];
            let events = [];
            //convert data to resources and event formats
            totalData?.getCalendarRows?.calendarRows.forEach((row, index) => {
                if (row.vehicle.status !== 'retired') {
                    resources.push({
                        id: row.vehicle.id,
                        index,
                        title: row.vehicle.year + " " + row.vehicle.make + " " + row.vehicle.modelName + " " + row.vehicle.trim,
                        extendedProps: {
                            vin: row.vehicle.vin,
                            v_id: row.vehicle.sourceVehicleId,
                            vmh_id: row.vehicleManagementHub.vmhId,
                            sh_id: row.vehicleManagementHub.shId,
                            status: row.vehicle.status,
                            vehicle: row.vehicle,
                        },
                        groupId: row.vehicle.make,
                    })
                    row.bookings.forEach((booking) => {
                        const scheduledReleasedAt = moment(booking.scheduledReleasedAt).format('YYYY-MM-DDTHH:mm:ssZ');
                        const scheduledReturnedAt = moment(booking.scheduledReturnedAt).format('YYYY-MM-DDTHH:mm:ssZ');

                        if (booking.status !== 'cancelled' && booking.status !== 'denied') {
                            const event = {
                                id: booking.id,
                                resourceId: row.vehicle.id,
                                display: 'block',
                                title: `(${moment(scheduledReleasedAt).format('h:mma').replace('m', '')} - ${moment(scheduledReturnedAt).format('h:mma').replace('m', '')} - ${getTimeZoneAbbreviation(row.vehicleManagementHub.city)}) ${booking.releasedTo.replace('null', '')}`,
                                start: scheduledReleasedAt,
                                end: scheduledReturnedAt,
                                color: booking.type === 'service' ? colours.primary.grey02 : booking.status.includes('pending') ? colours.accent.caution_yellow : booking.status == 'completed' || booking.actualReturnedAt !== null ? colours.accent.validate_green : colours.primary.blue,
                                extendedProps: {
                                    bookingId: booking.id,
                                    resourceId: row.vehicle.id,
                                    vehicleManagementHub: row.vehicleManagementHub,
                                    sourceBookingId: booking.sourceBookingId,
                                    userId: booking.userId,
                                    type: booking.type,
                                    booking,
                                    vehicle: row.vehicle
                                }
                            }

                            events.push(event)

                            const { startTime, endTime } = getTurnaroundTimes(scheduledReleasedAt, scheduledReturnedAt, row.vehicleManagementHub);

                            events.push({
                                id: booking.id + "_turnaround",
                                resourceId: row.vehicle.id,
                                display: 'background',
                                start: startTime,
                                end: endTime,
                                color: booking.type === 'service' ? colours.primary.grey03 : booking.status.includes('pending') ? colours.accent.light_yellow : booking.status == 'completed' || booking.actualReturnedAt !== null ? colours.accent.light_green : colours.functional.hover_primaryblue
                            })

                            // open new booking view pullout if there is a new booking
                            if (currentCreatedBooking && currentCreatedBooking.ID == row.vehicle.id) {
                                const currentBookingStart = moment(currentCreatedBooking.start).format('YYYY-MM-DDTHH:mm:ssZ');
                                const isSameBooking = moment(currentBookingStart).isSame(moment(scheduledReleasedAt));

                                if (isSameBooking) {
                                    props.dispatch(openPullout({ ...currentCreatedBooking, ...event, new: false, edit: false, draft: false, highlightEvent, onCancel: cancelEvent }));
                                    setCurrentCreatedBooking(null);
                                }
                            }
                        }
                    })
                }
            });
            setEvents(events);
            setResources(resources);
            setCalendarLoading(false);
        } else {
            setEvents([]);
            setResources([]);
        }
    }, [totalData])

    const togglePendingBookings = () => {
        setCalendarLoading(true);

        setFilterBy(currentFilterBy => {
            const isPendingBookingsFilterActive = currentFilterBy === 'pendingBookings';

            if (isPendingBookingsFilterActive) {
                refetchData({
                    startDate: moment().subtract(1, 'year').format('YYYY-MM-DD'),
                    endDate: moment().add(1, 'year').format('YYYY-MM-DD'),
                    stakeholderAndVehicleCenterInputs: filtersChecked.length > 0 ? formatFilters(filtersChecked) : props.userSession?.user?.profile_access?.active_sh_access,
                    vehicleSearchTerm: searchTerm,
                    filterInput: null,
                    first: 50,
                    after: null
                });

                return '';
            }

            return 'pendingBookings';
        })
    }

    return (
        <div className="bkg-white-dark shbookings-section" style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
            <Navbar history={props.history} match={props.match} location={props.location} />
            {/* <AlertBar page="bookings" loading={false} history={props.history} match={props.match} location={props.location} /> */}
            {/* <div className="flexed fixed-navbar-page fixed-alertbar-page" style={{flexDirection: 'column'}}> */}
            <div className="flexed fixed-navbar-page" style={{ flexDirection: 'column' }}>
                <div className='calendar-header'>
                    <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-start' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div className='ds-cal-filter-icon blue-hover' data-tip='One Month Back' data-delay-show={1000} style={{ display: 'flex', marginRight: 8, padding: 4, borderRadius: '8px' }} onClick={() => { getPrev() }}>
                                <Icon name="DoubleLeft" />
                            </div>
                            <div className='ds-cal-filter-icon blue-hover' data-tip='One Week Back' data-delay-show={1000} style={{ display: 'flex', marginRight: 8, padding: 4, borderRadius: '8px' }} onClick={() => { getHalfPrev() }}>
                                <Icon name="ChevronLeft" />
                            </div>
                            <div data-tip='To Today' data-delay-show={1000}>
                                <Button label="Today" onClick={() => { toToday() }} />
                            </div>
                            <div className='ds-cal-filter-icon blue-hover' data-tip='One Week Forward' data-delay-show={1000} style={{ display: 'flex', marginLeft: 8, padding: 4, borderRadius: '8px' }} onClick={() => { getHalfNext() }}>
                                <Icon name="ChevronRight" />
                            </div>
                            <div className='ds-cal-filter-icon blue-hover' data-tip='One Month Forward' data-delay-show={1000} style={{ display: 'flex', marginLeft: 8, padding: 4, borderRadius: '8px' }} onClick={() => { getNext() }}>
                                <Icon name="DoubleRight" />
                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <button
                                style={{ margin: '0 16px' }}
                                className={`button px-32 ${filterBy === 'pendingBookings' ? 'primary' : 'white border'}`}
                                onClick={togglePendingBookings}
                            >
                                <Trans>Pending Bookings</Trans>
                                {filterBy === 'pendingBookings' && (
                                    <img src="images/icon-close.png" className="close-icon" style={{ height: '13px', width: '13px', margin: '0 -2px 0 7px' }} />
                                )}
                                {/* {this.state.requests > 0 ? <div className = "number-badge alert mt-8">{this.state.requests}</div> : null} */}
                            </button>
                        </div>

                    </div>
                    <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
                        <P1Bold>{calendarTitle}</P1Bold>
                    </div>

                    <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }} ref={innerSettingsRef}>
                        <Button secondary leading_ic="Clock" label="Times Displayed: Local Vehicle Timezone" style={{ color: colours.primary.grey01 }} />
                        {/* <Tabs value={calendarView} onChange={(e) => {setCalendarView(e.currentTarget.dataset.id)}}> */}
                        {/* <TabItem value="rtweek" label="Week"/> */}
                        {/* <TabItem value="rtmo" label="Month"/> */}
                        {/* <TabItem value="rtThreeMonth" label="3 Month"/> */}
                        {/* <TabItem value="rtyear" label="Year"/> */}
                        {/* </Tabs> */}
                        <div className='ds-cal-filter-icon blue-hover' style={{ display: 'flex', marginLeft: 8, padding: 4, borderRadius: '8px' }} onClick={() => { setShowSettings(!showSettings) }}>
                            <Icon name="Settings" />
                        </div>
                        {showSettings ?
                            <div style={{ display: 'flex', position: 'absolute', zIndex: 5, top: 115, right: 15, minWidth: '160px', boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.2)', backgroundColor: 'white', border: 'solid 1px grey', padding: 8, flexDirection: 'column' }}>
                                <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
                                    <Toggle
                                        title='Show Weekends'
                                        checked={weekendsVisible}
                                        icons={false}
                                        onChange={() => {
                                            setWeekendsVisible(!weekendsVisible)
                                        }}
                                    />
                                    <P3 style={{ marginLeft: 8 }}>Show Weekends</P3>
                                </div>
                                <div style={{ marginTop: 8, marginBottom: 4 }}>
                                    <P3Bold style={{ textAlign: 'start' }}>Booking Types</P3Bold>
                                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', marginTop: 4 }}>
                                        <div style={{ borderRadius: 8, backgroundColor: colours.primary.grey02, width: 24, height: 24, marginRight: 8 }}></div>
                                        <P3>Service</P3>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', marginTop: 4 }}>
                                        <div style={{ borderRadius: 8, backgroundColor: colours.primary.blue, width: 24, height: 24, marginRight: 8 }}></div>
                                        <P3>Confirmed Booking</P3>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', marginTop: 4 }}>
                                        <div style={{ borderRadius: 8, backgroundColor: colours.accent.validate_green, width: 24, height: 24, marginRight: 8 }}></div>
                                        <P3>Approved Booking</P3>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', marginTop: 4 }}>
                                        <div style={{ borderRadius: 8, backgroundColor: colours.accent.caution_yellow, width: 24, height: 24, marginRight: 8 }}></div>
                                        <P3>Pending Booking</P3>
                                    </div>
                                </div>
                            </div>
                            : null}
                    </div>
                </div>
                <div id='calendar-container' onScroll={(event) => {
                    if (totalData) {
                        if (event.target && ((event.target.scrollTop + event.target.clientHeight - 50) >= event.target.firstChild?.scrollHeight)) {
                            getMoreData(); // subtract 50px for footer area
                        }
                    }
                }}>
                    {calendarLoading && (
                        <LoadingIcon />
                    )}
                    <div className={calendarLoading ? 'hidden' : ''}>
                        <FullCalendar
                            ref={calendarRef}
                            plugins={[resourceTimelinePlugin, interactionPlugin]}
                            initialView="rtmo"
                            initialDate={moment().subtract(5, 'days').format('YYYY-MM-DD')}
                            views={{
                                rtweek: {
                                    type: 'resourceTimeline',
                                    buttonText: 'Week',
                                    duration: { days: 7 },
                                    // slotLabelFormat: [
                                    //     { month: 'short', weekday: 'short', day: '2-digit' },
                                    //     { 
                                    //         hour: 'numeric',
                                    //         minute: '2-digit',
                                    //         omitZeroMinute: true,
                                    //         meridiem: 'short'
                                    //     }
                                    // ]
                                },
                                rtmo: {
                                    type: 'resourceTimeline',
                                    buttonText: 'Month',
                                    duration: { days: 30 },
                                    // slotLabelFormat: [
                                    //     {
                                    //         month: 'short'
                                    //     },
                                    //     {
                                    //         day: 'numeric'
                                    //     }
                                    // ]
                                },
                                rtThreeMonth: {
                                    type: 'resourceTimeline',
                                    buttonText: '3 Month',
                                    duration: { days: 90 },
                                    // slotLabelFormat: [
                                    //     {
                                    //         month: 'short'
                                    //     },
                                    //     {
                                    //         day: 'numeric'
                                    //     }
                                    // ]
                                },
                                rtyear: {
                                    type: 'resourceTimeline',
                                    duration: { days: 365 },
                                    buttonText: 'Year',
                                    // slotLabelFormat: [
                                    //     {
                                    //         month: 'short'
                                    //     },
                                    //     {
                                    //         day: 'numeric'
                                    //     }
                                    // ]
                                }
                            }}
                            resources={resources.length > 0 ? resources : loading || !called ? skeletonResources : []}
                            events={events}
                            selectable={true}
                            dayHeaderClassNames="ds-cal-resource-header"
                            resourceAreaHeaderClassNames="ds-cal-resource-header"
                            resourceOrder={'index'}
                            resourceAreaHeaderContent={(
                                <div style={{ height: '100%', marginTop: 6, flexDirection: 'row', display: 'flex', flex: 1, position: 'relative', alignItems: 'center', padding: '4px 8px' }}>
                                    <Input
                                        name="search"
                                        leading_ic="Search"
                                        trailing_ic={searchTerm == '' ? "" : "Close"}
                                        trailing_ic_onClick={clearSearchTerm}
                                        onChange={handleSearchVehicles}
                                        value={displaySearchTerm}
                                        placeholder="Search Vehicles"
                                    />
                                    {
                                        props.userSession?.user?.profile_access?.active_sh_vmh_access?.length > 1 ?
                                            <div style={{ marginLeft: 8, marginBottom: 12, display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'center', alignItems: 'center', overflow: 'visible' }}>
                                                <div className="ds-cal-filter-icon"><Icon name="Filter" onClick={() => { setShowFilters(!showFilters) }} style={filtersChecked.length > 0 ? { color: colours.primary.blue } : null} /></div>
                                            </div>
                                            : null
                                    }
                                </div>
                            )}
                            resourceAreaWidth={"20em"}
                            slotMinWidth={5}
                            slotDuration={{ hours: 1 }}
                            displayEventTime={false}
                            stickyHeaderDates
                            slotMinTime="09:00:00"
                            slotMaxTime="17:00:00"
                            resourceLabelContent={(data) => {
                                return (
                                    <div style={{ height: '50px' }}>
                                        <div className="calendar-resource-label">
                                            <div style={{ maxHeight: '50px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }} onClick={(e) => openVehicleDetails(data)}>
                                                <P2 style={{ height: '20px', width: '192px', maxWidth: '100%', minWidth: '100%' }}>
                                                    {data.resource.title ?
                                                        <HighLighter
                                                            text={data.resource.title}
                                                            searchTerm={searchTerm}
                                                            highlightedItemClass="ds-highlighted-search-text-P2"
                                                            itemClass="P2"
                                                        />
                                                        : <Skeleton />}
                                                </P2>
                                                <P3Bold style={{ height: '16px', color: colours.primary.grey02, width: '240px', minWidth: '100%' }}>
                                                    {data.resource.extendedProps.vin ?
                                                        <HighLighter
                                                            text={data.resource.extendedProps.vin}
                                                            searchTerm={searchTerm}
                                                            highlightedItemClass="ds-highlighted-search-text-P3Bold"
                                                            itemClass="P3Bold"
                                                        />
                                                        : <Skeleton />}
                                                </P3Bold>
                                            </div>
                                            <div style={{ maxHeight: '50px', display: 'flex', alignItems: 'center' }}>
                                                {DivisionIcon(props.userSession?.user?.profile_access?.active_sh_vmh_access.find((item) => { return item.SH_ID == data.resource.extendedProps.sh_id })?.stakeholder || null, null, null, null, true)}
                                                {VCIcon(props.userSession?.user?.profile_access?.active_sh_vmh_access.find((item) => { return item.VMH_ID == data.resource.extendedProps.vmh_id })?.vmh || null, null, null, null, true)}
                                            </div>
                                        </div>
                                    </div>
                                )
                            }}
                            select={handleDateSelect}
                            weekends={weekendsVisible}
                            eventClick={handleEventClick}
                            eventClassNames={["ds-cal-event"]}
                            resourceLabelClassNames={["ds-cal-resource"]}
                            slotLabelClassNames="slot-label"
                            schedulerLicenseKey='0701261002-fcs-1713379714'
                            height="100%"
                            unselectCancel='.booking_pullout'
                            nowIndicator={true}
                            contentHeight='auto'
                            headerToolbar={null}
                            slotLabelContent={(e) => {
                                if (e.view.type == 'rtmo') {
                                    let text = e.text?.split(' ');
                                    return (
                                        <>
                                            <div style={moment(e.date).isValid() && (moment(e.date).format('MM DD YYYY').toString() === moment().format('MM DD YYYY').toString()) ? { color: 'steelblue', fontWeight: 'bold' } : { color: 'grey', fontWeight: 'normal' }}>
                                                {text[0]}
                                            </div>
                                            <div style={moment(e.date).isValid() && (moment(e.date).format('MM DD YYYY').toString() === moment().format('MM DD YYYY').toString()) ? { color: 'steelblue', fontWeight: 'bold' } : { color: 'grey', fontWeight: 'normal' }}>
                                                {text[1]}
                                            </div>
                                        </>
                                    )
                                }
                                return (
                                    <div style={moment(e.date).isValid() && (moment(e.date).format('MM DD YYYY').toString() === moment().format('MM DD YYYY').toString()) ? { color: 'steelblue', fontWeight: 'bold' } : { color: 'grey', fontWeight: 'normal' }}>
                                        {e.text}
                                    </div>
                                )
                            }}
                        />
                    </div>
                    <div style={{ paddingTop: 16, paddingBottom: 16, backgroundColor: 'white', display: 'flex', flexDirection: 'row', flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                        {!calendarLoading && totalData?.getCalendarRows?.metaData?.nextCursor && (
                            <Button label={called && loading ? 'Loading...' : 'Load More'} disabled={called && loading} onClick={() => {
                                getMoreData();
                            }} />
                        )}
                    </div>
                </div>
                <div ref={innerFilterRef}>
                    {showFilters ?
                        <div style={{ display: 'flex', position: 'absolute', flexDirection: 'column', zIndex: 5, top: 200, left: 110, minWidth: '160px', boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.2)', backgroundColor: 'white', border: 'solid 1px grey', padding: 8, maxHeight: '400px', overflowY: 'auto' }}>
                            {props.userSession?.user?.profile_access?.active_vmh_access.length > 1 ?
                                <>
                                    <CaptionMedium style={{ marginBottom: 4 }}>Facilities</CaptionMedium>
                                    {filterNodesVC.map((item) => (
                                        <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                                            <div>
                                                <input
                                                    type="checkbox"
                                                    checked={checkedVCs && (checkedVCs.includes(item.value) || checkedVCs.indexOf(item.value) > 0)}
                                                    onChange={(ev) => {
                                                        if (ev.target.checked) {
                                                            let sh_ids = props.userSession?.user?.profile_access?.active_sh_vmh_access.filter((item2) => { return item2.VMH_ID == item.value });
                                                            if (sh_ids) {
                                                                setFiltersChecked(_.union([...filtersChecked, ...sh_ids.map((id) => { return id.SH_ID + "_" + item.value })]));
                                                            }
                                                        }
                                                        else {
                                                            let new_filters = filtersChecked.filter((s) => {
                                                                if (!s.includes(item.value)) {
                                                                    return s;
                                                                }
                                                            });
                                                            if (new_filters && new_filters.length > 0) {
                                                                while (new_filters.indexOf(undefined) !== -1) {
                                                                    let index = new_filters.indexOf(undefined);
                                                                    if (index !== -1)
                                                                        new_filters.splice(index, 1);
                                                                }
                                                                setFiltersChecked(_.union(new_filters));
                                                            } else {
                                                                setFiltersChecked([]);
                                                            }
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div>{item.icon}</div>
                                            <div style={{ padding: '0px 5px', width: '100%', textAlign: 'start', fontSize: '14px', fontWeight: 'normal', fontFamily: 'Lato' }}>{item.label}</div>
                                        </div>
                                    ))}
                                </>
                                : null}
                            {props.userSession?.user?.profile_access?.active_sh_access.length > 1 ?
                                <div>
                                    <CaptionMedium style={{ marginTop: 16, marginBottom: 4 }}>Pools</CaptionMedium>
                                    <CheckboxTree
                                        nodes={filterNodesSH}
                                        checked={filtersChecked}
                                        expanded={filtersExpanded}
                                        onCheck={checked => setFiltersChecked(checked)}
                                        onExpand={expanded => setFiltersExpanded(expanded)}
                                        showCheckbox={true}
                                        icons={icons}
                                    />
                                </div>
                                : null}
                        </div>
                        : null}
                </div>
            </div>
            <ModalRoutes match={props.match} history={props.history} />
        </div>
    );
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    settings: store.settings,
    stakeholder: store.stakeholder
})

export default connect(mapStateToProps)(SHBookings)